export default __webpack_public_path__ + "87a68248d7c74a4961eceb0bdac4732d.png";